// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3782Z","tab":"ProcedureTabs_tab__6hPp0"};